import FileType from './FileType'
import FileFormat from './FileFormat'
export class ExportFile {
    ID: number;
    Name: string;
    FileTypeID: number;
    FileType: FileType;
    FileFormatID: number;
    FileFormat: FileFormat;
    ShowCONAHeader: boolean;
}

export default ExportFile;